module.exports = __webpack_public_path__ + "img/scroll_top.1a28c2cb.svg";